import {ErrorMessage} from "../common/ETANotificationConfigs.style";
import {FC} from "react";
import styled from "@emotion/styled";

interface ETAInputWrapperWithErrorMessageProps {
  errorMessage?: string;
  width?: string;
}

export const ETAInputWrapperWithErrorMessage: FC<ETAInputWrapperWithErrorMessageProps> = ({
  errorMessage,
  children,
  width
}) => {
  return (
    <ErrorMessageContainer width={width}>
      {children}
      <ErrorMessage>{errorMessage}</ErrorMessage>
    </ErrorMessageContainer>
  );
};

export const ErrorMessageContainer = styled.div<{width?: string}>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: ${(props) => (props.width ? props.width : "fit-content")};

  position: relative;
`;
